// is data table ka data usergroup_det k table se ata he
// isko agr UserGroupOverview wali screen se usergroup ki id mile gi to ye is scree pr ae ga otherwise ye redirect kr jae ga UserGroupOverview wali screen pr
// is data table me se jis ko hum change kre ge sirf whi rows db me jae gi na k sari array

import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Input, FormGroup, Label } from "reactstrap";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Link, Redirect } from "react-router-dom";
import { Modal } from "react-bootstrap";
import "../formsTable.css";
// import "../baseForms.css";
// import "./../../PartyType/myReactSelect.css";
import "./myReactSelect.css";
import swal from "@sweetalert/with-react";
import { baseurl } from "../../../../baseurl";
import axios from "axios";
import { GetIp } from "../../../Forms/ShortCutComponents/Get_ip";
import ResponseLoader from "../../../Forms/ShortCutComponents/ResponseLoader";

export default function AddMenu(props) {
  var username = localStorage.getItem("username");
  var token = localStorage.getItem("token");
  var companyId = localStorage.getItem("companyId");
  const [loadingResponce, setLoadingResponce] = useState(false);
  const [checkId, setCheckId] = useState(false);
  const [data, setData] = useState({
    userModule: "",
    showModalAddNew: true,
  });
  const [table, setTable] = useState({
    OverViewDataTable: [],
  });
  const [insertTable, setInsertTable] = useState([]);

  useEffect(() => {
    const id = props?.EditData?.usergroup_id;
    const usergroup_id = props?.location?.state?.id;

    if (usergroup_id) {
      getData(usergroup_id);
    } else {
      setCheckId(true);
    }
    // !usergroup_id && setCheckId(true);
  }, []);

  const getData = (usergroup_id) => {
    // var offSet, pageSize;
    setLoadingResponce(true);

    axios
      .post(
        `${baseurl}/userModule/getUserMenu`,
        {
          companyId: companyId,
          username: username,
          report: 1,
          id: usergroup_id,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((res) => {
        setLoadingResponce(false);
        setTable({
          OverViewDataTable: res.data.data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const formatFirstColumn = (cell, row, rowIndex) => {
    const headingStyle = {
      fontWeight: row.parent_yn === 1 ? "bold" : "normal",
      fontSize: row.parent_yn === 1 ? "16px" : "14px",
      textAlign: "left",
      // color: row.parent_yn === 1 ? "green" : "",
      // backgroundColor: row.parent_yn === 1 ? "green" : "",
      // marginLeft: row.parent_yn !== 1 ? "100px" : " ",
      pointerEvents: "none", // This disables pointer events, making the row non-interactive
      userSelect: "none", // This prevents text selection in the cell
    };

    return <div style={headingStyle}>{cell}</div>;
  };

  const getUserIp = async function () {
    let res = await GetIp();
    return {
      userIp: res.ip,
      userCountry: res.country,
    };
    setData({
      ...data,
      userIp: res.ip,
      userCountry: res.country,
    });
  };

  const renderCheckbox = (cell, row, enumObject, rowIndex, dataField) => {
    return (
      <input
        type="checkbox"
        checked={cell}
        onChange={(event) =>
          handleCheckboxChange(event, rowIndex, dataField, cell, row)
        }
        //  disabled={row.parent_yn === 1} // Disable the checkbox for the first row
      />
    );
  };
  // Function to handle checkbox change
  const handleCheckboxChange = (event, rowIndex, dataField, cell, row) => {
    const cellName = dataField;
    const newValue = event.target.checked;
    const parent_yn = row.parent_yn;
    let newInsertArray = insertTable;
    let frontenedArray = table.OverViewDataTable;

    const findId = newInsertArray.findIndex(
      (item) => item.node_no === row.node_no
    );

    if (parent_yn) {
      for (let i = rowIndex; i < frontenedArray.length; i++) {
        if (frontenedArray[i].parent_yn === 1 && i !== rowIndex) {
          // End the loop when the next parent_yn is 1
          break;
        }
        const index = newInsertArray.findIndex(
          (item) => item.node_no === frontenedArray[i].node_no
        );
        if (index > -1) {
          if (cellName == "add_yn") {
            frontenedArray[i].add_yn = newValue;
            newInsertArray[index].add_yn = newValue;
          } else if (cellName == "edit_yn") {
            frontenedArray[i].edit_yn = newValue;
            newInsertArray[index].edit_yn = newValue;
          } else if (cellName == "delete_yn") {
            frontenedArray[i].delete_yn = newValue;
            newInsertArray[index].delete_yn = newValue;
          } else if (cellName == "view_yn") {
            frontenedArray[i].view_yn = newValue;
            newInsertArray[index].view_yn = newValue;
          }
        } else {
          if (cellName == "add_yn") {
            frontenedArray[i].add_yn = newValue;
          } else if (cellName == "edit_yn") {
            frontenedArray[i].edit_yn = newValue;
          } else if (cellName == "delete_yn") {
            frontenedArray[i].delete_yn = newValue;
          } else if (cellName == "view_yn") {
            frontenedArray[i].view_yn = newValue;
          }
          newInsertArray.push(frontenedArray[i]);
        }
      }
    } else {
      if (findId > -1) {
        if (cellName == "add_yn") {
          frontenedArray[rowIndex].add_yn = newValue;
          newInsertArray[findId].add_yn = newValue;
        } else if (cellName == "edit_yn") {
          frontenedArray[rowIndex].edit_yn = newValue;
          newInsertArray[findId].edit_yn = newValue;
        } else if (cellName == "delete_yn") {
          frontenedArray[rowIndex].delete_yn = newValue;
          newInsertArray[findId].delete_yn = newValue;
        } else if (cellName == "view_yn") {
          frontenedArray[rowIndex].view_yn = newValue;
          newInsertArray[findId].view_yn = newValue;
        }
      } else {
        if (cellName == "add_yn") {
          row.add_yn = newValue;
        } else if (cellName == "edit_yn") {
          row.edit_yn = newValue;
        } else if (cellName == "delete_yn") {
          row.delete_yn = newValue;
        } else if (cellName == "view_yn") {
          row.view_yn = newValue;
        }
        newInsertArray.push(row);
      }
    }

    setTable({
      OverViewDataTable: frontenedArray,
    });
    setInsertTable(newInsertArray);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoadingResponce(true);

    var companyId = localStorage.getItem("companyId");

    // return;
    let { userIp, userCountry } = await getUserIp();
    if (1 === 1) {
      // let Id = props.EditData;
      axios
        .post(
          `${baseurl}/userModule/updateAddMenu`,
          {
            companyId,
            usergroup_id: props?.location?.state?.id,
            formValues: insertTable,
            activityName: "Update Report Rights",
            activityLink: "/reportRights",
            username: username,
            userIp,
            userCountry,
          },
          {
            headers: {
              authorization: token,
            },
          }
        )

        .then(function (response) {
          setLoadingResponce(false);
          swal({
            title: "Saved Successfully!",
            text: "Report Rights Updated",
            icon: "success",
          }).then((value) => {
            window.location.href = "/#/UserGroupOverview";
          });
        })
        .catch(function (error) {
          console.log(error);
          setLoadingResponce(false);

          swal({
            title: "Error",
            text: "Something went wrong, try to refresh the page and try again.",
            icon: "error",
          });
        });
    } else {
      swal({
        // title: `${checkAlpha} ${checkBlnc} ${checkAmt} `,
        title: `Errrrrorrr `,
        text: "Invalid",
        icon: "warning",
      }).then((value) => {
        setLoadingResponce(false);
      });
    }
  };

  const options = {
    paginationShowsTotal: true,
    page: 1,
    sizePerPage: 15,
    pageStartIndex: 1,
    paginationSize: 5,
    prePage: "Prev",
    nextPage: "Next",
    firstPage: "First",
    lastPage: "Last",
    prePageTitle: "Go to previous",
    nextPageTitle: "Go to next",
    firstPageTitle: "Go to first",
    lastPageTitle: "Go to Last",
    paginationPosition: "top",
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "30",
        value: 30,
      },
      {
        text: "50",
        value: 50,
      },
      {
        text: "100",
        value: 100,
      },
      {
        text: "All",
        value: table.OverViewDataTable?.length,
      },
    ],
  };
  const rowStyle = (row, rowIndex) => {
    // Here, you can define your condition to color the row
    // For example, if you want to color rows where cash_account is 'desired_value'
    if (row?.parent_yn === 1) {
      return {
        backgroundColor: "#969494", // Use your desired color here
        // color: "white", // Set the text color for better visibility
      };
    }
  };
  const formatUrl = (cell, row) => {
    console.log("row>>>>>>", row);
    if (!row.parent_yn) {
      return (
        // <a href={cell} target="_blank" rel="noopener noreferrer">
        //   {row.name} {/* Example: You can access other row properties */}
        // </a>
        <Link
          to={{
            pathname: cell,
          }}
          className=" "
        >
          {row.name}
        </Link>
      );
    }
  };

  return (
    <>
      {loadingResponce ? (
        <ResponseLoader />
      ) : checkId ? (
        <Redirect to="/UserGroupOverview" />
      ) : (
        <div>
          <div className="row   m-1">
            <div className="col-md-8">
              <strong>
                <h3>{props?.location?.state?.name}</h3>
              </strong>
              <p className="p-3">
                Below are the users roll allow to this Group.
              </p>
            </div>
          </div>

          <hr
            style={{
              borderTop: "1px solid rgb(221, 221, 221)",
              width: "96%",
              position: "relative",
              // left: "-15px",
            }}
          />
          <BootstrapTable
            data={table.OverViewDataTable}
            striped
            pagination
            hover
            // className="example"
            search
            tableHeaderClass="rpr_header"
            tableBodyClass="rpr_body"
            containerClass="rpr_container"
            headerStyle={{
              position: "sticky",
              top: "0",
              //  zIndex: "1000"
            }}
            options={options}
            version="4"
            trStyle={rowStyle}
          >
            <TableHeaderColumn
              dataAlign="center"
              dataField="name"
              isKey={true}
              width="50%"
              dataFormat={formatFirstColumn}
              // dataFormat={dueFormators}
              dataSort={true}
            >
              Report Rights
            </TableHeaderColumn>
            <TableHeaderColumn
              dataAlign="center"
              dataField="url"
              width="20%"
              dataFormat={formatUrl} // Pass function here
              dataSort={true}
            >
              URL
            </TableHeaderColumn>
            {/* <TableHeaderColumn
              dataAlign="center"
              dataField="add_yn"
              width="10%"
              dataFormat={(cell, row, enumObject, rowIndex) =>
                renderCheckbox(cell, row, enumObject, rowIndex, "add_yn")
              }
              dataSort={true}
            >
              Add
            </TableHeaderColumn>
            <TableHeaderColumn
              dataAlign="center"
              dataField="edit_yn"
              width="10%"
              dataFormat={(cell, row, enumObject, rowIndex) =>
                renderCheckbox(cell, row, enumObject, rowIndex, "edit_yn")
              }
              dataSort={true}
            >
              Edit
            </TableHeaderColumn>
            <TableHeaderColumn
              dataAlign="center"
              dataField="delete_yn"
              width="10%"
              dataFormat={(cell, row, enumObject, rowIndex) =>
                renderCheckbox(cell, row, enumObject, rowIndex, "delete_yn")
              }
              editable={false}
              dataSort={true}
            >
              Dell
            </TableHeaderColumn> */}
            <TableHeaderColumn
              dataAlign="center"
              dataField="view_yn"
              width="10%"
              dataFormat={(cell, row, enumObject, rowIndex) =>
                renderCheckbox(cell, row, enumObject, rowIndex, "view_yn")
              }
              dataSort={true}
            >
              View
            </TableHeaderColumn>

            {/* <TableHeaderColumn
              dataAlign="center"
              width="30%"
              // dataFormat={orderDetHandler}
              dataField="id"
              // row="0"
              // rowSpan="2"
              // className="rpr_header"
            >
              Action
                  </TableHeaderColumn> */}
          </BootstrapTable>
          <hr
            style={{
              border: "1px solid ",
              marginBottom: "3vh",
              marginTop: "3vh",
              borderColor: "E4E5E6",
            }}
          />
          <div className="py-2">
            <Button
              className="mr-1 invoiceSubmitButton "
              // disabled={loadingResponce}
              hidden={false}
              onClick={handleSubmit}
            >
              Save Changes
            </Button>
            <Link
              to="/UserGroupOverview"
              // to={{
              //   pathname: "/addPayment",
              //   // goBackUrl: "/ManualJournalEntryAdd",
              //   state: {
              //     id: prop?.id,
              //     attachment: 1,
              //     type: 1,
              //   },
              // }}
            >
              <Button className="mr-1" size="sm" hidden={false}>
                Cancel
              </Button>
            </Link>
          </div>
        </div>
      )}
    </>
  );
}
